import { inject, singleton } from "tsyringe";
import { COOKIES } from "@identity/symbols";
import { QueryString } from "./query-string";

@singleton()
export class ExperimentBucketing {
  constructor(
    @inject(COOKIES) private readonly cookiesManager: CookiesManager,
  ) {}

  getCurrentBucket(): string {
    const forcedBucket = QueryString.get("pf_pathfinder_force_bucket");

    if (typeof forcedBucket === "string" && forcedBucket?.length > 0) {
      return forcedBucket;
    }

    return this.cookiesManager.get("exp_bucket") || "100";
  }
}
